<template>
  <div style="margin-top: 100px">
    
    
    <button @click="exportToPDF">Export to PDF</button>
    

    <div style="margin-top: 20px;" id="element-to-convert">

      <div style="height: 80px;">
        <div class="">
          <a href="/" class="logo-link active"></a>
          <div class="text-center"><h6>TOP DISCOUNT</h6></div>
          <div class="text-center">Created By: <b>Anton Naydenov</b></div>
        </div>
      </div>

      <table class="table table-sm" v-for="record in plan" :key="record.id" style="margin-bottom: 20px;">
        <thead>
        <tr>
          <th style="color: black">
            <h6>{{ record.translation[locale] ? record.translation[locale].name : record.translation['en'].name }}</h6>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in record.subRecord" :key="item.id">
          <td style="padding-left: 50px;color: black">

            <h6>{{ item.translation[locale] ? item.translation[locale].name : item.translation['en'].name }}</h6>

            <table class="table" v-if="item.steps && item.steps.length">
              <tbody>
              <tr v-for="step in item.steps" :key="step.id">
                <td>
                  <h6>{{ step.translation[locale] ? step.translation[locale].name : step.translation['en'].name }}</h6>
                </td>
              </tr>
              </tbody>
            </table>

            <table class="table" v-if="item.subRecord && item.subRecord.length">
              <tbody>
              <tr v-for="rec in item.subRecord" :key="rec.id">
                <td>
                  <h6>{{ rec.translation[locale] ? rec.translation[locale].name : rec.translation['en'].name }}</h6>

                  <table class="table" v-if="rec.steps && rec.steps.length">
                    <tbody>
                    <tr>
                      <td v-for="step in rec.steps" :key="step.id">

                        <h6>{{
                            step.translation[locale] ? step.translation[locale].name : step.translation['en'].name
                          }}</h6>

                        <p v-if="step.project_steps && step.project_steps.description != ''"
                           v-html="step.project_steps.description"></p>
                      </td>
                    </tr>
                    </tbody>
                  </table>

                </td>
              </tr>
              </tbody>
            </table>
          </td>
        </tr>
        </tbody>
      </table>

      <h6 style="padding-left: 20px;">Performance visualization</h6>
      <table class="table table-sm">
        <thead>
        <tr>
          <th style="color: black">
            Income chart
          </th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td style="color: black">
            <BudgetSection :token="$route.params.token" :show-items="false" :cat="incomeCategory"
                           :budget="defaultBudget"
                           :key="incomeCategory.id"></BudgetSection>
          </td>
        </tr>
        </tbody>
      </table>
      <table class="table table-sm">
        <thead>
        <tr>
          <th style="color: black">
            Costs chart
          </th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td style="color: black">

            <BudgetSection :token="$route.params.token" :show-items="false" :cat="expensesCategory"
                           :budget="defaultBudget"
                           :key="expensesCategory.id"></BudgetSection>
          </td>
        </tr>
        </tbody>
      </table>
      <table class="table table-sm">
        <thead>
        <tr>
          <th style="color: black">
            Summary chart
          </th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td style="color: black">

                        <BudgetSummary
                            :token="$route.params.token"
                            v-if="defaultBudget"
                            :budget="defaultBudget">
                        </BudgetSummary>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!--    <Breadcrumbs title="Plan"/>-->


    <!--    <div id="element-to-convert">-->

    <!--      <div v-for="record in plan" :key="record.id">-->

    <!--        <h5>{{ record.translation[locale] ? record.translation[locale].name : record.translation['en'].name }}</h5>-->

    <!--        <div  v-for="item in record.subRecord" :key="item.id">-->

    <!--          <div >-->
    <!--            <h5 style="line-height: 30px;">-->
    <!--              {{ item.translation[locale] ? item.translation[locale].name : item.translation['en'].name }}-->
    <!--            </h5>-->

    <!--            <div v-if="item.steps && item.steps.length" class="pl-2">-->
    <!--              <div v-for="step in item.steps" :key="step.id">-->
    <!--                <h6>{{ step.translation[locale] ? step.translation[locale].name : step.translation['en'].name }}</h6>-->
    <!--                <p v-if="step.project_steps && step.project_steps.description != ''"-->
    <!--                   v-html="step.project_steps.description"></p>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div>-->

    <!--            <div v-if="item.subRecord && item.subRecord.length">-->

    <!--              <div v-for="rec in item.subRecord" :key="rec.id">-->
    <!--                <h5 style="line-height: 30px;">-->
    <!--                  {{-->
    <!--                    rec.translation[locale] ? rec.translation[locale].name : rec.translation['en'].name-->
    <!--                  }}-->
    <!--                </h5>-->

    <!--                <div v-if="rec.steps && rec.steps.length" class="pl-2">-->
    <!--                  <div class="card p-4" v-for="step in rec.steps" :key="step.id">-->
    <!--                    <h6>{{-->
    <!--                        step.translation[locale] ? step.translation[locale].name : step.translation['en'].name-->
    <!--                      }}</h6>-->
    <!--                    <p v-if="step.project_steps && step.project_steps.description != ''"-->
    <!--                       v-html="step.project_steps.description"></p>-->
    <!--                  </div>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div v-if="plan.length && defaultBudget">-->
    <!--        <div class="html2pdf__page-break"></div>-->
    <!--        <h5 style="margin-top: 30px;">Performance visualization</h5>-->
    <!--        <div class="card mt-4">-->

    <!--          <div class="card-header">-->
    <!--            <h5 style="line-height: 30px;">-->
    <!--              Income chart-->
    <!--            </h5>-->
    <!--          </div>-->
    <!--          <div class="card-body" v-if="incomeCategory" >-->
    <!--            <BudgetSection :token="$route.params.token" :show-items="false" :cat="incomeCategory" :budget="defaultBudget"-->
    <!--                           :key="incomeCategory.id"></BudgetSection>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div class="html2pdf__page-break"></div>-->
    <!--        <div class="card mt-4">-->
    <!--          <div class="card-header">-->
    <!--            <h5 style="line-height: 30px;">-->
    <!--              Costs chart-->
    <!--            </h5>-->
    <!--          </div>-->
    <!--          <div class="card-body">-->
    <!--            <BudgetSection :token="$route.params.token" :show-items="false" :cat="expensesCategory" :budget="defaultBudget"-->
    <!--                           :key="expensesCategory.id"></BudgetSection>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div class="html2pdf__page-break"></div>-->
    <!--        <div class="card mt-4">-->
    <!--          <div class="card-header">-->
    <!--            <h5 style="line-height: 30px;">-->
    <!--              Summary chart-->
    <!--            </h5>-->
    <!--          </div>-->
    <!--          <div class="card-body">-->
    <!--            <BudgetSummary-->
    <!--                :token="$route.params.token"-->
    <!--                v-if="defaultBudget"-->
    <!--                :budget="defaultBudget">-->
    <!--            </BudgetSummary>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->

  </div>
</template>


<script>

import BudgetSummary from "../Budget/BudgetSummary";
import BudgetSection from "../Budget/BudgetSection"
import html2pdf from "html2pdf.js";

export default {
  name: 'PdfProjectExport',
  components: {BudgetSummary, BudgetSection},
  data() {
    return {
      defaultBudget: false,
      incomeCategory: null,
      expensesCategory: null
    };
  },
  async created() {

    await this.$store.dispatch('planExport/loadPlanPdf', {id: this.$route.params.id, token: this.$route.params.token})
    await this.$store.dispatch('budget/getAllPdf', {id: this.$route.params.id, token: this.$route.params.token})
  },
  beforeDestroy() {
    this.$store.dispatch('planExport/resetProjectExport')
  },
  methods: {

    exportToPDF() {

      var opt = {
        margin: 0.1,
        filename: 'myfile.pdf',
        image: {type: 'jpeg', quality: 0.98},
        html2canvas: {scale: 2},
        jsPDF: {unit: 'in', format: 'A4', orientation: 'portrait'}
      };

      html2pdf().set(opt).from(document.getElementById('element-to-convert')).save()

    },
    goToAssigment(record) {

      this.$router.push(
          {
            name: 'ProjectPlan',
            params: {
              id: this.$route.params.id,
              module: record.parent.parent_id
            },
            query: {
              'section': record.parent_id,
              'assignment': record.project_steps.id
            }
          })
    },
    async loadDefault(budget) {

      this.defaultBudget = await this.$store.dispatch("budget/getSinglePdf", {
        id: budget.id,
        token: this.$route.params.token
      })

      this.incomeCategory = this.defaultBudget.categories.find((cat) => {
        return cat.name == 'Revenue'
      })

      this.expensesCategory = this.defaultBudget.categories.find((cat) => {
        return cat.name == 'Expenses'
      })
    }
  },
  watch: {
    // whenever question changes, this function will run
    mainBudget(budget) {
      this.loadDefault(budget)
    }
  },
  computed: {

    plan: function () {

      let plans = this.$store.getters['planExport/getProjectExport']

      let main = plans.filter(function (plan) {
        return plan.parent_id == null
      })

      main.sort((a, b) => a.order - b.order || a.id - b.id);

      main.forEach(function (plan) {

        plan.subRecord = plans.filter(function (subRecord) {
          return subRecord.parent_id == plan.id
        })

        plan.subRecord.sort((a, b) => a.order - b.order || a.id - b.id);

        plan.subRecord.forEach((item) => {

          if (item.steps && item.steps.length) {

            item.steps.forEach((t) => {
              let translationArray = t.translation;
              t.translation = {}

              translationArray.forEach((r) => {
                t.translation[r.locale] = {
                  name: r.name
                }
              })

            })
          }

          item.subRecord = plans.filter(function (record) {
            return record.parent_id == item.id
          })

          item.subRecord.sort((a, b) => a.order - b.order || a.id - b.id);

          item.subRecord.forEach((rec) => {

            if (rec.steps && rec.steps.length) {

              rec.steps.sort((a, b) => a.id - b.id);

              rec.steps.forEach((t) => {

                let translationArray = t.translation;
                t.translation = {}

                translationArray.forEach((r) => {
                  t.translation[r.locale] = {
                    name: r.name
                  }
                })

              })
            }
          })

        })
      })

      return main
    },
    locale: function () {
      return this.$i18n.locale
    },
    mainBudget() {

      let budgets = this.$store.getters['budget/getBudgets']

      return budgets.find((item) => {
        return item.default
      })
    },
  }
};
</script>